var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRndr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 3.12c7.113 0 12.88 5.767 12.88 12.88S23.113 28.88 16 28.88 3.12 23.113 3.12 16c0-2.762.87-5.32 2.349-7.417a2.66 2.66 0 1 0-.804-.8A13.937 13.937 0 0 0 1.998 16c0 7.732 6.268 14 14 14s14-6.268 14-14S23.732 2 16 2v1.12zM22.44 16A6.44 6.44 0 1 1 9.56 16a6.44 6.44 0 0 1 12.88 0zm-14-9.66a1.54 1.54 0 1 1-3.08 0 1.54 1.54 0 0 1 3.08 0z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRndr);
export default __webpack_public_path__ + "static/media/RNDR.6d3592fda5d4607081eb30b38600d9d7.svg";
export { ForwardRef as ReactComponent };